import React from "react";
import Zoom from "@mui/material/Zoom";
import Grid from "@mui/material/Grid";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AddBoxIcon from "@mui/icons-material/AddBoxOutlined";
import ExposureIcon from "@mui/icons-material/Exposure";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import ConsoleCoordinates from "./ConsoleCoordinates.jsx";
/**
 * Controls css styling for this component using js to css
 */
let css = {
  grid: {
    width: "100%",
    height: "100%",
    maxHeight: 55
  },
  oval: {
    width: 16,
    height: 10,
    borderRadius: "50%",
    border: "2px solid",
    background: "transparent",
    marginBottom: 2,
    marginRight: 3
  },
  circle: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    border: "2px solid",
    background: "transparent",
    marginBottom: 2,
    marginRight: 3
  },
  buttonText: {
    fontSize: 13
  }
};

/**
 * Main component which controls and displays the console's longitude and latitude
 * selectors and handles user click events.
 *
 * @component
 */
export default function ConsoleLonLatSelects(props) {

  const [posEastWest, setPosEastWest] = React.useState(props.coordinateSystem.direction);
  const [coordSystem, setCoordSystem] = React.useState(props.coordinateSystem.system);
  const [lonRange, setLonRange] = React.useState(props.coordinateSystem.range);

  window.addEventListener("message", function(e) {
      if (typeof e.data == "string") {
        if (e.data.includes("setCoordSystem")) {
          // Remove "setCoordSystem " instruction and trim decimals
          let receivedCoordSystem = e.data.replace(/^setCoordSystem\s/i, "").toLowerCase();
          
          if (typeof receivedCoordSystem != "undefined") {
            if (receivedCoordSystem.includes("west")) {
              window.mouseControl.setCardinalEast();
              setPosEastWest("west");
            } else {
              window.mouseControl.setCardinalWest();
              setPosEastWest("east");
            }

            if (receivedCoordSystem.includes("centric")) {
              window.mouseControl.setSysCentric();
              setCoordSystem("centric");
            } else {
              window.mouseControl.setSysGraphic();
              setCoordSystem("graphic");
            }

            if (receivedCoordSystem.includes("180")) {
              window.mouseControl.setDomain180();
              setLonRange("180");
            } else {
              window.mouseControl.setDomain360();
              setLonRange("360");
            }
          }

        }
      }
    },
    false
  );

  const handlePosEastWest = (event, newPosEastWest) => {
    if (newPosEastWest !== null) {
      if(newPosEastWest === "west") {
        window.mouseControl.setCardinalWest();
      } else {
        window.mouseControl.setCardinalEast();
      }
      setPosEastWest(newPosEastWest);
    }
  };

  const handleCoordSystem = (event, newCoordSystem) => {
    if (newCoordSystem !== null) {
      if (newCoordSystem === "centric") {
        window.mouseControl.setSysCentric();
      } else {
        window.mouseControl.setSysGraphic();
      }
      setCoordSystem(newCoordSystem);
    }
  };

  const handleLonRange = (event, newLonRange) => {
    if (newLonRange !== null) {
      if (newLonRange === "180") {
        window.mouseControl.setDomain180();
      } else {
        window.mouseControl.setDomain360();
      }
      setLonRange(newLonRange);
    }
  };

  // const classes = useStyles();

  return (
    <>
      <ToggleButtonGroup
        color="primary"
        className="appbar-tog-btn"
        exclusive
        size="small"
        value={posEastWest}
        onChange={handlePosEastWest}
      >
        <ToggleButton id="consoleLonEastBtn" value="east">
          <AutorenewIcon fontSize="small" sx={{transform: "scaleY(-1)"}} />
          <Typography sx={css.buttonText}>East</Typography>
        </ToggleButton>
        <ToggleButton id="consoleLonWestBtn" value="west">
          <AutorenewIcon fontSize="small" />
          <Typography sx={css.buttonText}>West</Typography>
        </ToggleButton>
      </ToggleButtonGroup>

      <Tooltip
        title={
          <Typography variant="subtitle1">
            Planetocentric or Planetographic
          </Typography>
        }
        enterDelay={800}
        leaveDelay={0}
        arrow
        TransitionComponent={Zoom}
      >
        <ToggleButtonGroup
          color="primary"
          className="appbar-tog-btn"
          exclusive
          size="small"
          value={coordSystem}
          onChange={handleCoordSystem}
        >
          <ToggleButton
            value="centric"
            id="consoleLatTypeOcentric"
          >
            <i style={css.circle} />
            <Typography sx={css.buttonText}>centric</Typography>
          </ToggleButton>
          <ToggleButton
            id="consoleLatTypeOgraphic"
            value="graphic"
          >
            <i style={css.oval} />
            <Typography sx={css.buttonText}>graphic</Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </Tooltip>

      <ToggleButtonGroup
        color="primary"
        className="appbar-tog-btn"
        exclusive
        size="small"
        value={lonRange}
        onChange={handleLonRange}
      >
        <ToggleButton id="consoleLon180Btn" value="180">
          <ExposureIcon fontSize="small" />
          <Typography sx={css.buttonText}>180&deg;</Typography>
        </ToggleButton>
        <ToggleButton id="consoleLon360Btn" value="360">
          <AddBoxIcon fontSize="small" />
          <Typography sx={css.buttonText}>360&deg;</Typography>
        </ToggleButton>
      </ToggleButtonGroup>
      <ConsoleCoordinates/>
    </>
  );
}
